module.exports = __webpack_public_path__ + "static/media/image14.a998163e.JPG";